(() => {
  if (window.velenciTryOnDisclosureLoaded) return;
  window.velenciTryOnDisclosureLoaded = true;

  const TRY_ON_MARKER = "- TRY ON";
  const POLICY_VERSION = "July 29, 2026";

  const modal = document.getElementById(
    "velenci-tryon-disclosure"
  );

  const dialog = modal?.querySelector(
    ".velenci-tryon-disclosure__dialog"
  );

  const checkbox = document.getElementById(
    "velenci-tryon-agreement-checkbox"
  );

  const acceptButton = document.getElementById(
    "velenci-tryon-disclosure-accept"
  );

  const errorElement = document.getElementById(
    "velenci-tryon-disclosure-error"
  );

  const scrollArea = document.getElementById(
    "velenci-tryon-disclosure-scroll"
  );

  const scrollMessage = document.getElementById(
    "velenci-tryon-scroll-message"
  );

  const agreementLabel = modal?.querySelector(
    ".velenci-tryon-disclosure__agreement"
  );

  const mobileQuery = window.matchMedia(
    "(max-width: 749px)"
  );

  if (!modal || !dialog || !checkbox || !acceptButton) {
    console.error(
      "[Velenci Try-On Disclosure] Required popup elements were not found."
    );

    return;
  }

  let checkoutInProgress = false;
  let lastFocusedElement = null;

  function itemIsTryOn(item) {
    const productTitle = String(
      item.product_title || ""
    ).toUpperCase();

    const variantTitle = String(
      item.variant_title || ""
    ).toUpperCase();

    const fullTitle = String(
      item.title || ""
    ).toUpperCase();

    const properties = item.properties || {};

    return (
      productTitle.includes(TRY_ON_MARKER) ||
      variantTitle.includes(TRY_ON_MARKER) ||
      fullTitle.includes(TRY_ON_MARKER) ||
      properties._tryon === true ||
      properties._tryon === "true" ||
      properties.TryOn === true ||
      properties.TryOn === "true"
    );
  }

  async function getCart() {
    const response = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Could not verify the cart.");
    }

    return response.json();
  }

  async function cartContainsTryOn() {
    const cart = await getCart();

    return (
      Array.isArray(cart.items) &&
      cart.items.some(itemIsTryOn)
    );
  }

  async function updateTryOnBodyClass() {
    try {
      const hasTryOn = await cartContainsTryOn();

      document.body.classList.toggle(
        "velenci-cart-has-tryon",
        hasTryOn
      );

      return hasTryOn;
    } catch (error) {
      console.error(
        "[Velenci Try-On Disclosure]",
        error
      );

      return null;
    }
  }

  function isMobileDisclosure() {
    return mobileQuery.matches;
  }

  function hasReachedScrollBottom() {
    if (!scrollArea) return true;

    const remainingDistance =
      scrollArea.scrollHeight -
      scrollArea.scrollTop -
      scrollArea.clientHeight;

    return remainingDistance <= 8;
  }

  function unlockMobileAgreement() {
    checkbox.disabled = false;

    agreementLabel?.classList.remove(
      "is-locked"
    );

    if (scrollMessage) {
      scrollMessage.textContent =
        "Agreement reviewed. You may now check the box below.";

      scrollMessage.classList.add(
        "is-complete"
      );
    }
  }

  function lockMobileAgreement() {
    checkbox.checked = false;
    checkbox.disabled = true;
    acceptButton.disabled = true;

    agreementLabel?.classList.add(
      "is-locked"
    );

    if (scrollMessage) {
      scrollMessage.textContent =
        "Scroll through the complete agreement to continue.";

      scrollMessage.classList.remove(
        "is-complete"
      );
    }
  }

  function prepareAgreementForDisplay() {
    checkbox.checked = false;
    acceptButton.disabled = true;

    if (!isMobileDisclosure()) {
      checkbox.disabled = false;

      agreementLabel?.classList.remove(
        "is-locked"
      );

      if (scrollMessage) {
        scrollMessage.classList.remove(
          "is-complete"
        );
      }

      return;
    }

    if (scrollArea) {
      scrollArea.scrollTop = 0;
    }

    window.requestAnimationFrame(() => {
      if (hasReachedScrollBottom()) {
        unlockMobileAgreement();
      } else {
        lockMobileAgreement();
      }
    });
  }

  function openDisclosure() {
    lastFocusedElement = document.activeElement;

    prepareAgreementForDisplay();

    acceptButton.textContent =
      "Accept & Continue to Checkout";

    errorElement.hidden = true;
    errorElement.textContent = "";

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    document.body.classList.add(
      "velenci-tryon-modal-open"
    );

    window.setTimeout(() => {
      dialog.focus();
    }, 10);
  }

  function closeDisclosure() {
    if (checkoutInProgress) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    document.body.classList.remove(
      "velenci-tryon-modal-open"
    );

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus === "function"
    ) {
      lastFocusedElement.focus();
    }
  }

  function showError(message) {
    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  function formatNewYorkTime(date) {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short"
    }).format(date);
  }

  async function saveAgreementAcceptance() {
    const acceptedAt = new Date();

    const readableTime =
      formatNewYorkTime(acceptedAt);

    const isoTime = acceptedAt.toISOString();

    const response = await fetch(
      "/cart/update.js",
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          attributes: {
            "Try-On Agreement Accepted":
              "Yes",

            "Try-On Agreement Accepted At":
              readableTime,

            "Try-On Agreement Accepted At ISO":
              isoTime,

            "Try-On Agreement Version":
              POLICY_VERSION,

            "Try-On Refund Policy":
              "https://www.velenci.com/pages/refund-policy",

            "Try-On FAQ":
              "https://www.velenci.com/pages/faq"
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        "The agreement acceptance could not be saved."
      );
    }

    const cart = await response.json();

    if (
      cart.attributes?.[
        "Try-On Agreement Accepted"
      ] !== "Yes"
    ) {
      throw new Error(
        "Shopify did not confirm the saved agreement."
      );
    }
  }

  function isCheckoutButton(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    const control = element.closest(
      [
        'button[name="checkout"]',
        'input[name="checkout"]',
        'a[href="/checkout"]',
        'a[href*="/checkout"]',
        "[data-checkout-button]",
        "[data-cart-checkout]",
        '[data-action="checkout"]',
        ".cart__checkout-button",
        ".cart-drawer__checkout-button"
      ].join(",")
    );

    if (control) return control;

    const button = element.closest(
      'button[type="submit"], input[type="submit"], a'
    );

    if (!button) return null;

    const text = String(
      button.textContent ||
      button.value ||
      button.getAttribute("aria-label") ||
      ""
    )
      .trim()
      .toLowerCase();

    if (
      text.includes("checkout") ||
      text.includes("check out")
    ) {
      return button;
    }

    return null;
  }

  async function handleCheckoutAttempt(event) {
    const checkoutButton =
      isCheckoutButton(event.target);

    if (!checkoutButton) return;

    /*
      Stop Prestige immediately before checking the cart.
    */
    event.preventDefault();
    event.stopPropagation();

    if (
      typeof event.stopImmediatePropagation ===
      "function"
    ) {
      event.stopImmediatePropagation();
    }

    if (checkoutInProgress) return;

    try {
      const hasTryOn =
        await updateTryOnBodyClass();

      if (hasTryOn === null) {
        openDisclosure();

        showError(
          "We could not verify your cart. Please close this window and try again."
        );

        return;
      }

      if (hasTryOn) {
        openDisclosure();
        return;
      }

      window.location.assign("/checkout");
    } catch (error) {
      console.error(
        "[Velenci Try-On Disclosure]",
        error
      );

      openDisclosure();

      showError(
        "We could not verify your cart. Please close this window and try again."
      );
    }
  }

  document.addEventListener(
    "click",
    handleCheckoutAttempt,
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const submitter = event.submitter;

      if (!submitter) return;
      if (!isCheckoutButton(submitter)) return;

      handleCheckoutAttempt(event);
    },
    true
  );

  checkbox.addEventListener(
    "change",
    () => {
      acceptButton.disabled =
        !checkbox.checked;

      if (checkbox.checked) {
        errorElement.hidden = true;
        errorElement.textContent = "";
      }
    }
  );

  scrollArea?.addEventListener(
    "scroll",
    () => {
      if (!isMobileDisclosure()) return;
      if (!checkbox.disabled) return;

      if (hasReachedScrollBottom()) {
        unlockMobileAgreement();
      }
    }
  );

  if (
    typeof mobileQuery.addEventListener ===
    "function"
  ) {
    mobileQuery.addEventListener(
      "change",
      () => {
        if (
          !modal.classList.contains(
            "is-open"
          )
        ) {
          return;
        }

        prepareAgreementForDisplay();
      }
    );
  } else if (
    typeof mobileQuery.addListener ===
    "function"
  ) {
    mobileQuery.addListener(() => {
      if (
        !modal.classList.contains(
          "is-open"
        )
      ) {
        return;
      }

      prepareAgreementForDisplay();
    });
  }

  acceptButton.addEventListener(
    "click",
    async () => {
      if (
        !checkbox.checked ||
        checkoutInProgress
      ) {
        return;
      }

      checkoutInProgress = true;

      acceptButton.disabled = true;
      acceptButton.textContent =
        "Saving your acceptance…";

      errorElement.hidden = true;
      errorElement.textContent = "";

      try {
        const hasTryOn =
          await cartContainsTryOn();

        if (!hasTryOn) {
          window.location.assign(
            "/checkout"
          );

          return;
        }

        await saveAgreementAcceptance();

        acceptButton.textContent =
          "Continuing to checkout…";

        window.location.assign(
          "/checkout"
        );
      } catch (error) {
        console.error(
          "[Velenci Try-On Disclosure]",
          error
        );

        checkoutInProgress = false;

        acceptButton.disabled =
          !checkbox.checked;

        acceptButton.textContent =
          "Accept & Continue to Checkout";

        showError(
          "Your acceptance could not be saved. Please try again."
        );
      }
    }
  );

  modal
    .querySelectorAll(
      "[data-tryon-disclosure-close]"
    )
    .forEach((element) => {
      element.addEventListener(
        "click",
        closeDisclosure
      );
    });

  document.addEventListener(
    "keydown",
    (event) => {
      if (
        event.key === "Escape" &&
        modal.classList.contains(
          "is-open"
        )
      ) {
        closeDisclosure();
      }
    }
  );

  [
    "cart:refresh",
    "cart:updated",
    "cart:change",
    "cart:changed"
  ].forEach((eventName) => {
    document.addEventListener(
      eventName,
      updateTryOnBodyClass
    );
  });

  updateTryOnBodyClass();
})();